import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
//if component <h1>{this.props.t('lang')}</h1>

function Pic8({ t }) {

    return (
        <div className="mainLayout">
            <div className="mainLayOutInner">
                <br />

                <div className="imageWraper">
                <img src="/images/8.jpg" className="pic1M" alt="pic1" />

                <div className="pic1MDisc">
                    <div>Lyndon Polan, Untitled, Huile sur panneau de bois, 11.5x11.5, 2020</div>
                </div>
                <span className="arrow1"> <Link to="/7">{"<"}</Link> </span><span className="arrow2"> <Link to="/9">{">"}</Link></span>
                </div>

                





            </div>
        </div>
    );
}


export default withTranslation()(Pic8);